import { render, staticRenderFns } from "./wp-editor.vue?vue&type=template&id=0091274d&scoped=true&"
import script from "./wp-editor.vue?vue&type=script&lang=js&"
export * from "./wp-editor.vue?vue&type=script&lang=js&"
import style0 from "./wp-editor.vue?vue&type=style&index=0&id=0091274d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0091274d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0091274d')) {
      api.createRecord('0091274d', component.options)
    } else {
      api.reload('0091274d', component.options)
    }
    module.hot.accept("./wp-editor.vue?vue&type=template&id=0091274d&scoped=true&", function () {
      api.rerender('0091274d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/common/wp-editor.vue"
export default component.exports